// @ts-nocheck
import React, { useState, useEffect, useMemo } from "react";
import { flatten, pipe, map } from "ramda";

import Grid from "@mui/material/Grid";
import TreeView from "@mui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Button } from "../../UI/MUIButton";
import { useNetwork } from "../../hooks/useNetwork";
import { CreateSubnetworkModal } from "../../routes/super_admin/network_settings/modals/CreateSubnetworkModal";
import { MergeSubnetworkModal } from "../../routes/super_admin/network_settings/modals/MergeSubnetworkModal";
import { Network } from "../../services/NetworkApi";

import { SubnetworkTreeItem } from "./SubnetworkTreeItem";

export interface IProps {
  expandAsDefault?: boolean,
  isPreview?: boolean;
  showArchived?: boolean;
}

const PREVIEW_SUBTITLE = "Expand to see all unit types."; 

export const SubnetworksTree: React.FC<IProps> = (props) => {
  const { expandAsDefault } = props || {};
  const { selectedNetwork, getL2Options } = useNetwork();
  const [ subnetworks, setSubnetworks ] = useState<Array<Network>>([]);
  const [isCreateSubnetworkModal, setIsCreateSubnetworkModal] = React.useState(false);
  const [isMergeMatchingRoundsModal, setIsMergeMatchingRoundsModal] = React.useState(false);

  const sortMatchingRounds = (a: Network, b: Network) => a.l2Name > b.l2Name? 1 : -1;
  const sortL3 = (a: Network, b: Network) => a.name > b.name? 1: -1;
  
  useEffect(() => {
    const subnetworks = getL2Options(selectedNetwork.l1Id).filter(l2 => props.showArchived? l2 : l2.matchingRoundStatus !== "ARCHIVED") as Network[];
    const sortedSubnetworks = subnetworks
      .sort(sortMatchingRounds)
      .map(el => ({
        ...el,
        l3: el.l3.sort(sortL3)
       }));
    
    setSubnetworks(sortedSubnetworks);
  }, [props.showArchived, selectedNetwork]);

  const nodesId = useMemo(() => expandAsDefault
    ? pipe(
      map((subnetwork: Network) =>
        [`${subnetwork.l1Name}-${subnetwork.l2Id}`, ...(subnetwork?.l3 ? subnetwork?.l3?.map(unitType => `${subnetwork.l1Name}-${subnetwork.l2Id}-${unitType.l3Id}`) : [])]
      ),
      flatten
    )(subnetworks)
    : []
    , [expandAsDefault, subnetworks]);

  const openCreateSubnetworkModal = () => setIsCreateSubnetworkModal(true);

  const closeCreateSubnetworkModal = () => setIsCreateSubnetworkModal(false);

  const openMergeMatchingRoundsModal = () => setIsMergeMatchingRoundsModal(true);
  const closeMergeMatchingRoundsModal = () => setIsMergeMatchingRoundsModal(false);

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs>
        <TreeView
          disableSelection
          defaultExpandIcon={<ChevronRightIcon />}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpanded={nodesId}
        >
          {subnetworks.map((subnetwork: Network) => (
            <SubnetworkTreeItem
              key={subnetwork.l2Id}
              subnetwork={subnetwork}
              subtitle1={props.isPreview? PREVIEW_SUBTITLE : undefined}
              isPreview={props.isPreview}
              expandAsDefault={expandAsDefault}
              {...subnetwork}
            />
          ))}
        </TreeView>
      </Grid>
      {
        (subnetworks.length !== 0 || subnetworks.length === 0 && !props.showArchived) && !props.isPreview && (<Grid container gap={3}>
          <Grid item>
            <Button variant="outlined" onClick={openCreateSubnetworkModal}>
              Add new Matching Round
            </Button>
            <CreateSubnetworkModal
              l1Id={selectedNetwork.l1Id}
              show={isCreateSubnetworkModal}
              onClose={closeCreateSubnetworkModal}
            />
          </Grid>
          <Grid item>
          <Button variant="outlined" onClick={openMergeMatchingRoundsModal}>
            Add new matching round from previous
          </Button>
            <MergeSubnetworkModal
              show={isMergeMatchingRoundsModal} 
              onClose={closeMergeMatchingRoundsModal} 
              l1Id={selectedNetwork.l1Id}
            />
        </Grid>
        </Grid>)
      }
    </Grid >
  );
};

SubnetworksTree.defaultProps = {
  isPreview: false,
};
